import { render } from "./MyExpertise.vue?vue&type=template&id=86002824&scoped=true"
import script from "./MyExpertise.vue?vue&type=script&lang=js"
export * from "./MyExpertise.vue?vue&type=script&lang=js"

import "./MyExpertise.vue?vue&type=style&index=0&id=86002824&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86002824"]])

export default __exports__